import React, { FC } from 'react';
import { BooleanInput, NumberInput, SelectArrayInput, useTranslate } from 'react-admin';
import { l } from '~/utils/solutions';
import { useStyles } from '~/hooks/useSolutionsStyles';
import OperationTypeInput from '~/components/OperationTypeInput';

interface ReversalPartnerFormProps {
  keyName: string;
}

export const ReversalPartnerForm: FC<ReversalPartnerFormProps> = ({ keyName }) => {
  const classes = useStyles();
  const translate = useTranslate();
  const t = (key: string): string => translate(l(`featuresConfig.${key}`));

  const operationTypeChoices = (OperationTypeInput.getChoices(translate) as Array<{
    id: string;
    name: string;
  }>).filter((choice) => choice.id !== '');

  return (
    <>
      <SelectArrayInput
        label={t('allowedOperationTypes')}
        source={`${keyName}.allowedOperationTypes`}
        choices={operationTypeChoices}
        className={classes.inputWidth}
      />
      <NumberInput
        label={t('reversalWindowMinutes')}
        source={`${keyName}.reversalWindowMinutes`}
        className={classes.inputWidth}
      />
      <BooleanInput
        label={t('checkAmount')}
        source={`${keyName}.checkAmount`}
        className={classes.inputWidth}
      />
      <BooleanInput
        label={t('revertTenantFees')}
        source={`${keyName}.revertTenantFees`}
        className={classes.inputWidth}
      />
    </>
  );
};
